import { Grid, Tab, Tabs } from '@mui/material';
import { map } from 'lodash';
import React, { useState } from 'react';
import { type FC } from 'react';

import TabPanel from '../TabPanel';
import { type SettingsModalTabProps } from '../types';

import AuditTab from './AuditTab';
import PermissionRequestsTab from './PermissionRequestsTab';
import PermissionsTab from './PermissionsTab';
import RolesTab from './RolesTab';

import { useAccess } from '@/Contexts/Permissions';

const PermissionsManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index, showHeading }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { canAnywhere } = useAccess();
  const handleMainTabChange = (_: React.SyntheticEvent, newValue: number) => setActiveTab(newValue);

  const buildTabs = (): { [key: string]: FC<SettingsModalTabProps> } => {
    let tabsList: { [key: string]: FC<SettingsModalTabProps> } = {
      Users: PermissionsTab,
      Roles: RolesTab,
      Requests: PermissionRequestsTab,
    };

    if (canAnywhere('view', 'permission_management')) {
      tabsList = { ...tabsList, Audit: AuditTab };
    }

    return tabsList;
  };

  const availableTabs = buildTabs();

  return (
    <TabPanel value={parentTab} index={index} heading="Permission Management" showHeading={showHeading}>
      <Tabs value={activeTab} onChange={handleMainTabChange} sx={{ flexShrink: 0 }}>
        {map(Object.keys(availableTabs), (label, idx) => (
          <Tab key={`permissions-tab-label-${idx}`} label={label} />
        ))}
      </Tabs>
      <Grid size={12} sx={{ borderTop: '1px solid rgba(0,0,0,0.12)', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {map(Object.values(availableTabs), (TabComponent, idx) => (
          <TabComponent key={`permissions-tab-content-${idx}`} parentTab={activeTab} index={idx} />
        ))}
      </Grid>
    </TabPanel>
  );
};

export default PermissionsManagementTab;
